import { PhotoUploadQueueList } from '../photoUpload/PhotoUploadQueueList';
import type { GalleryUploadItem } from './useGalleryUploadQueue';

export interface GalleryUploadQueueProps {
  items: GalleryUploadItem[];
  busy: boolean;
  onRetry: (id: string) => void;
  onClear: () => void;
}

/** Per-file status list of the gallery upload queue (the shared PhotoUploadQueueList). */
export function GalleryUploadQueue({ items, busy, onRetry, onClear }: GalleryUploadQueueProps) {
  return (
    <PhotoUploadQueueList
      items={items}
      busy={busy}
      onRetry={onRetry}
      onClear={onClear}
      titleLevel={2}
      testIdPrefix="gallery-upload"
    />
  );
}
